import React from 'react';

import isMobile from 'ismobilejs';
import { createRoot } from 'react-dom/client';

import PageLoaderApp from '../../components/container/Common/PageLoader/PageLoaderApp';

import applyThemeAndTranslate from '../../Hooks/Common/applyThemeAndTranslate';

const MOUNT_TAG = 'page-loader';
const MOUNTED_ATTR = 'data-page-loader-mounted';

const getOrCreateMount = (): Element => {
    let mount = document.querySelector(MOUNT_TAG);
    if (!mount) {
        mount = document.createElement(MOUNT_TAG);
        document.body.prepend(mount);
    }
    return mount;
};

const bootstrap = (): void => {
    if (!isMobile.any) {
        try {
            document.documentElement.removeAttribute('data-pageloader-pending');
        } catch (e) {
            /* ignore */
        }
        return;
    }

    const mount = getOrCreateMount();

    if (mount.hasAttribute(MOUNTED_ATTR)) return;
    mount.setAttribute(MOUNTED_ATTR, '');

    const WrappedApp = applyThemeAndTranslate(PageLoaderApp);
    createRoot(mount).render(<WrappedApp />);
};

if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', bootstrap, { once: true });
    } else {
        bootstrap();
    }
}
